import { render, staticRenderFns } from "./telegram_subscription.vue?vue&type=template&id=5801c850&scoped=true&"
import script from "./telegram_subscription.vue?vue&type=script&lang=js&"
export * from "./telegram_subscription.vue?vue&type=script&lang=js&"
import style0 from "./telegram_subscription.vue?vue&type=style&index=0&id=5801c850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5801c850",
  null
  
)

export default component.exports